<template>
  <CustomPage title="选择申诉商品" :noBorder="true" style="background: #f7f7f7">
    <div
      slot="content"
      class="
        flex flex-col
        items-center
        h-full
        justify-between
        pb-8
        text-sm
        px-3
      "
    >
      <div class="w-full">
        <div class="bg-white my-3 p-3 rounded-lg">
          订单编号：{{ $route.params.id }}
        </div>
        <CheckboxGroup
          v-model="result"
          ref="checkboxGroup"
          class="bg-white my-3 p-3 rounded-lg"
        >
          <div v-for="item in items" :key="item.id" class="flex my-2">
            <Checkbox
              class="flex-shrink-0"
              checked-color="#ee0a24"
              :name="item.id"
              :disabled="item.afterSale"
            ></Checkbox>
            <div class="w-20 h-20 mx-2 flex-shrink-0">
              <img
                class="w-full h-full rounded"
                :src="item.goodsInfoImg"
                alt=""
              />
            </div>

            <div class="flex flex-col justify-between w-full">
              <div>{{ item.goodsInfoName }}</div>
              <div class="flex justify-between">
                <div class="text-red font-semibold">￥{{ item.dealPrice }}</div>
                <Stepper v-model="item.AftQty" integer :max="item.qty" />
              </div>
            </div>
          </div>
        </CheckboxGroup>
        <div>申诉退款后无法恢复优惠券/红包还需要返还赠品</div>
        <Checkbox @click="checkAll" v-model="all" checked-color="#ee0a24"
          >全部商品选择售后</Checkbox
        >
      </div>

      <Button
        class="h-8 w-10/12"
        color="red"
        round
        size="large"
        plain
        @click="next"
        >下一步</Button
      >
      <CustomView />
    </div>
  </CustomPage>
</template>

<script>
import CustomView from "@/components/custom-view.vue";
import CustomPage from "@/components/custom-page.vue";
import { Button, Checkbox, CheckboxGroup, Stepper } from "vant";
export default {
  components: {
    CustomView,
    CustomPage,
    Button,
    Checkbox,
    CheckboxGroup,
    Stepper,
  },
  created() {
    let params = this.$route.params;
    this.items = params.items;
    this.totalNum = params.items.reduce((prev, cur) => prev + cur.qty, 0);
    this.aftSaleReason = params.aftSaleReason;
    this.actId = params.actId;
  },
  data() {
    return {
      items: [],
      aftSaleReason: "",
      actId: null,
      result: [],
    };
  },
  methods: {
    checkAll() {
      const list = this.items.filter(item => !item.afterSale)
      this.result = list.map(item => item.id)
    },
    next() {
      if (!this.result.length) return;
      let temp = [];
      this.result.map((id) => {
        this.items.map((item) => {
          if (id === item.id) {
            temp.push({
              orderItemId: id,
              qty: item.AftQty,
              imgUrl: item.goodsInfoImg,
              actPrice: item.actPrice,
              spec: item.spec,
            });
            return;
          }
        });
      });

      this.$router.replace({
        name: "ApplyAftSale",
        params: {
          id: this.$route.params.id,
          items: temp,
          aftSaleReason: this.aftSaleReason,
          actId: this.actId,
          allRefund:
            temp.reduce((prev, cur) => prev + cur.qty, 0) === this.totalNum,
        },
      });
    },
  },
  computed: {
    all: {
      get() {
        return this.result.length === this.items.length;
      },
      set(val) {},
    },
  },
};
</script>

<style>
</style>